import React from "react";
import { Box, Typography, Divider, Paper } from "@mui/material";
import { calculateAge } from "../../utility/general";

/**
 * TemplatePatientFocus
 * A layout that prioritizes the patient's identity above all else
 * by using a large, colored "patient header" block.
 */
export default function TemplateAlt4({ 
    reportData, 
    color, 
    letterheadUrl, 
    labName, 
    labLocation, 
    renderRow 
}) {
  const reports = reportData?.patientTestReports || [];

  return (
    <Box sx={{ p: 2, background: '#f9f9f9' }}>
      
      {/* 1. Patient Focus Header */}
      <Paper 
        elevation={2} 
        sx={{ 
          p: 2, 
          mb: 2, 
          background: color, // Use the theme color
          color: '#fff',       // White text
          borderRadius: 2
        }}
      >
        <Typography variant="overline" sx={{ opacity: 0.8 }}>Patient</Typography>
        <Typography variant="h4" sx={{ fontWeight: 700, letterSpacing: '0.5px' }}>
          {reportData?.patientFullName || (reportData?.walkInPatient?.firstName + ' ' + reportData?.walkInPatient?.lastName) || "N/A"}
        </Typography>
         <Typography variant="overline" sx={{ opacity: 0.8 }}>Gender</Typography>
        <Typography variant="h4" sx={{ fontWeight: 700, letterSpacing: '0.5px' }}>
          {reportData?.gender || reportData?.walkInPatient?.gender  || "N/A"}
        </Typography>
        <Typography variant="overline" sx={{ opacity: 0.8 }}>Age</Typography>
        <Typography variant="h4" sx={{ fontWeight: 700, letterSpacing: '0.5px' }}>
          {calculateAge(reportData?.walkInPatient?.dateOfBirth) || "N/A"}
        </Typography>
        {/* You could add Patient ID, DOB, etc. here */}
      </Paper>

      {/* 2. Report & Lab Info (Secondary) */}
      <Box 
        sx={{ 
          display: 'flex', 
          justifyContent: 'space-between', 
          alignItems: 'flex-start',
          p: 1,
          mb: 2,
        }}
      >
        <Box>
          <Typography variant="h6" sx={{ fontWeight: 700 }}>{labName}</Typography>
          <Typography variant="body2" sx={{ color: "#666" }}>{labLocation}</Typography>
        </Box>
        <Box sx={{ textAlign: 'right' }}>
          {letterheadUrl && (
            <Box 
              component="img" 
              src={letterheadUrl} 
              alt="letterhead" 
              sx={{ width: 50, height: 50, objectFit: "contain", mb: 1 }} 
              data-letterhead="true" 
            />
          )}
          <Typography variant="body2" sx={{ color: '#555' }}>
            <strong>Report Date:</strong> {new Date().toLocaleDateString()}
          </Typography>
        </Box>
      </Box>

      <Divider sx={{ mb: 3 }} />

      {/* 3. Detailed Results (Uses your original card stack) */}
      <Box>
        {reports.map((r) => (
          <Paper 
            key={r.id} 
            sx={{ 
              mb: 2, 
              borderRadius: 2, 
              boxShadow: "0 2px 8px rgba(0,0,0,0.06)", 
              overflow: "hidden" 
            }}
          >
            <Box sx={{ background: "#fff", p: 1.5, borderBottom: '1px solid #eee' }}>
              <Typography variant="subtitle1" sx={{ fontWeight: 700, color: color }}>
                {r.internalLabService?.name}
              </Typography>
            </Box>
            <Box sx={{ p: 1.5, background: '#fff' }}>
              {renderRow(r)}
            </Box>
          </Paper>
        ))}
      </Box>
    </Box>
  );
}